module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-1-photo-8-bfc0054d16ee16e1da68442e5ddd1d26.webp";